import { Component, OnInit, Input } from '@angular/core';
import { ProcedureFourService } from '../../services/procedures/procedure-four.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import {environment} from '../../../environments/environment';
import {FilesService} from "../../services/files.service";

@Component({
  selector: 'ngx-procedure-four',
  templateUrl: './procedure-four.component.html',
  styleUrls: ['./procedure-four.component.scss'],
})
export class ProcedureFourComponent implements OnInit {
  @Input() stationId;
  loading = false;
  canEdit = true;
  state = 'Actividades';
  objectives = [
    {
      id: 'cumplirPlan',
      objective: 'Cumplir el plan de capacitación y entrenamiento establecido por la organización, para mejorar el desarrollo de las actividades realizadas por el personal dentro de la estación de servicio, a través de la aprobación del Programa de Capacitación ',
      goal: 'Brindar el 90% de las capacitaciones establecidas en el plan de capacitación y entrenamiento, en el año 2019.',
      measures: 'Establecimiento de los cursos a proporcionar al personal.',
      means: 'Programa de capacitación. Autorización de presupuesto para cumplir con el programa de capacitación. Sala de capacitación',
      responsable: 'Área administrativa',
      commitmentDate: '',
      nextMeasurementDate: '',
      editMedition: false,
      formula: {
        dividendo: {
          name: 'Total de cursos impartidos',
          value: 0,
        },
        divisor: {
          name: 'Total de cursos programados',
          value: 0,
        },
      },
    },
    {
      id: 'aplicarMedidas',
      objective: 'Aplicar las medidas de mitigación y prevención propuestas, para la reducción de los impactos ambientales generados por la estación de servicio para la etapa de preparación del sitio y construcción, mediante la ejecución de las actividades descritas en la Matriz de Identificación y Evaluación de Impactos',
      goal: 'Cumplir con el 100% de  las medidas  de mitigación y prevención aspectos ambientales para la reducción de los impactos ambientales identificados, durante el año la etapa de preparación del sitio y construcción.',
      measures: 'Ejecución de las medidas propuestas en el Informe Preventivo considerando aquellas que representen un menor costo de aplicación.',
      means: 'Autorización de presupuesto para el cumplimiento de las medidas.',
      responsable: 'Área administrativa',
      commitmentDate: '',
      nextMeasurementDate: '',
      editMedition: false,
      formula: {
        dividendo: {
          name: 'Total de medidas realizadas',
          value: 0,
        },
        divisor: {
          name: 'Total de medidas propuestas',
          value: 0,
        },
      },
    },
    {
      id: 'aplicarRequisitos',
      objective: 'Aplicar los requisitos legales establecidos en el Formato (FOR-SAES-{acronym}-006), para evitar multas por incumplimiento, mediante la coordinación y ejecución de los requerimientos establecidos en dicho formato.',
      goal: 'Llevar a cabo el 100% de los requisitos legales aplicables a la organización, durante el año 2019.',
      measures: 'Gestión para el cumplimiento de los requisitos legales establecidos en Formato 006',
      means: 'Autorización de presupuesto para el cumplimiento de los requisitos. Formato 006',
      responsable: 'Área administrativa',
      commitmentDate: '',
      nextMeasurementDate: '',
      editMedition: false,
      formula: {
        dividendo: {
          name: 'Total de requisitos legales cumplidos',
          value: 0,
        },
        divisor: {
          name: 'Total de requisitos legales aplicables',
          value: 0,
        },
      },
    },
    {
      id: 'analizarSistema',
      objective: 'Analizar el desempeño del sistema de administración de la organización, para asegurar su correcto funcionamiento y una mejora continua, mediante la revisión del Informe de Evaluación del Desempeño ',
      goal: 'Obtener el 100% de desempeño en los resultados del Formato 18 para el año 2020.',
      measures: 'Realización de las Auditorías establecidas en el Programa de Auditorías FOR-SAES-031',
      means: 'Participación del personal en las actividades relacionadas con el SA. Programa de Auditorías(FOR-SAES-031)',
      responsable: 'Área administrativa',
      commitmentDate: '',
      nextMeasurementDate: '',
      editMedition: false,
      formula: {
        dividendo: {
          name: 'Total de requisitos cumplidos',
          value: 0,
        },
        divisor: {
          name: 'Total de requisitos evaluados en el informe',
          value: 0,
        },
      },
    },
  ];

  responsables = [
    'Área administrativa',
    'Responsable de la estación de servicio',
    'Área de mantenimiento',
    'Responsable técnico',
    'Personal de mantenimiento',
    'Encargado de estación de servicio',
  ];

  documents = {
    objectives: '',
  };

  downloading = false;

  constructor(
    private procedureService: ProcedureFourService,
    private fileService: FilesService,
  ) { }

  ngOnInit() {
    this.getObjectives();
    this.generateDocument();
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  async saveResponses() {
    this.loading = true;
    const [error] = await this.procedureService.saveObjectives(this.stationId, this.objectives) as any;
    if (error) { this.loading = false; return this.alert('Oops, intenta más tarde', 'error'); }
    await this.getObjectives();
    this.alert('Datos guardados con éxito');
    this.canEdit = false;
    this.loading = false;
  }

  async getObjectives() {
    this.loading = true;
    const [error, result] = await this.procedureService.getObjectives(this.stationId) as any;
    this.loading = false;
    if (error) return this.alert('Oops, intenta más tarde', 'error');
    if (result.data.objectives) {
      this.objectives = result.data.objectives;
      this.canEdit = false;
    }
  }

  async generateDocument() {
    this.documents.objectives = `${environment.baseEndpoint}/filesGeneratorv2/implementation/four/step/one/${this.stationId}`;
  }

  generateUrl (objective: string) {
    const url = `${environment.baseEndpoint}/filesGeneratorv2/implementation/four/step/two/${objective}/${this.stationId}`;
    this.downloadFile(url, objective);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }
}
